import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store= new Vuex.Store({
    state: {
        companyList: [],
        taxRateList: [],
        accounts: []
  },
  mutations: {
  },
    actions: {
        GetComapanyList: function (commit, companyList) {
             //eslint-disable-line
            store.state.companyList = companyList;
        },
        
        GetAccountList: function (commit, accounts) {
             //eslint-disable-line
            store.state.accounts = accounts;
        },
        GetTaxRateList: function (commit, taxRateList) {
             //eslint-disable-line
            store.state.taxRateList = taxRateList;
        }
    },
  modules: {
  }
});
